import React from 'react';
import TruncatedMessage from './truncated_message';
import MessageStatusNotice from './message_status_notice';
import WaiverAnswers from './waiver_answers';
import PurifiedContent from './purified_content';

interface LogEntryContentProps {
  item: any;
  messageMaxHeight?: number;
}

const LogEntryContent = ({ item, messageMaxHeight }: LogEntryContentProps) => {
  const truncatedMessageMaxHeight = messageMaxHeight || 300;

  return (
    <div>
      {item.message && <PurifiedContent>{item.message}</PurifiedContent>}{' '}
      {!item.message && item.type == 'conversation_log_entry' && (
        <span>
          {(item.data.channel == 'sms' || item.data.channel == 'email') && (
            <span>
              Sent {item.data.channel} to{' '}
              {item.data.channel == 'sms' ? item.contact_phone_number : item.contact_email}{' '}
            </span>
          )}
          {item.data.channel == 'push_notification' && (
            <span>
              Sent push notification{' '}
              {item.contact_id !== item.push_notification_device_owner_id && (
                <span>to device(s) owned by {item.push_notification_device_owner_name}</span>
              )}
            </span>
          )}
          <TruncatedMessage data={item.data} maxHeight={truncatedMessageMaxHeight} />
        </span>
      )}
      {!item.message && item.type === 'sms_failure_log_entry' && (
        <span>
          Failed to send SMS to {item.contact_phone_number} ({item.data.failure_reason}){' '}
          <TruncatedMessage data={item.data} maxHeight={0}></TruncatedMessage>
        </span>
      )}
      {!item.message && item.type === 'push_notification_failure_log_entry' && (
        <span>
          Failed to send Push Notification{' '}
          <TruncatedMessage data={item.data} maxHeight={0}></TruncatedMessage>
        </span>
      )}
      {(item.data.reply_body?.length > 0 || item.type === 'note_log_entry') && (
        <div>
          <TruncatedMessage
            data={item.data}
            maxHeight={truncatedMessageMaxHeight}
          ></TruncatedMessage>
        </div>
      )}
      {item.type === 'signed_waiver_log_entry' && item.data.waiver_answers && (
        <WaiverAnswers data={item.data} />
      )}
      <MessageStatusNotice item={item} />
    </div>
  );
};

export default LogEntryContent;
